/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
const slotSettings = {
  label: "Slot Settings",
  keyName: "slotConfig"
};
const generateSlots = (layout = "") => {
  let slotSettingForArrow = [
    "ArrowThreeColGrid",
    "ArrowThreeColSixStories",
    "ArrowTwoColThreeStories",
    "ArrowTwoColFourStories",
    "ArrowThreeColSevenStory",
    "ArrowOneColStoryList",
    "ArrowElevenStories",
    "ArrowCollectionFilter"
  ];
  if (slotSettingForArrow.includes(layout)) {
    return slotSettings;
  }
};

const generateShowHideSettings = layout => {
  const showHideSetting = [
    {
      label: "Section Tag",
      type: "checkbox",
      keyName: "showSection"
    },
    {
      label: "Author Name",
      type: "checkbox",
      keyName: "showAuthor"
    },
    {
      label: "Publish Time",
      type: "checkbox",
      keyName: "showTime"
    },
    {
      label: "Time to read",
      type: "checkbox",
      keyName: "showReadTime"
    },
    {
      label: "Row Title",
      type: "checkbox",
      keyName: "showRowTitle"
    }
  ];
  const layoutsName = ["ArrowElevenStories"];
  const layoutsWithCustomCollectionName = ["ArrowThreeColSevenStory", "ArrowFourColGrid"];

  const withSeperator = {
    label: "seperator",
    type: "checkbox",
    keyName: "withseparator"
  };

  const rowTitle = {
    label: "Row Title",
    type: "text",
    keyName: "customCollectionName"
  };

  if (layoutsName.includes(layout)) {
    return [...showHideSetting, withSeperator];
  }
  if (layoutsWithCustomCollectionName.includes(layout)) {
    return [...showHideSetting, rowTitle];
  }
  return showHideSetting;
};

const generateStyles = layout => {
  const styles = [
    { label: "Theme", type: "colorPicker", keyName: "theme" },
    { label: "Border", type: "dropDown", keyName: "border" }
  ];
  const theme = [{ label: "Theme", type: "colorPicker", keyName: "theme" }];

  const border = [
    "ArrowThreeColGrid",
    "ArrowFourColGrid",
    "ArrowThreeColSixStories",
    "ArrowTwoColThreeStories",
    "ArrowCollectionFilter",
    "ArrowFourStorySlider",
    "ArrowHalfScreenSlider"
  ];

  const border1 = ["ArrowTwoColFourStories", "ArrowThreeColSevenStory"];
  const border2 = ["ArrowOneColStoryList"];
  const dropDownOptions = [{ label: "default", value: "" }, { label: "border", value: "full" }];
  const dropDownOptions1 = [{ label: "default", value: "" }, { label: "border", value: "bottom" }];
  const dropDownOptions2 = [
    { label: "default", value: "No Value" },
    { label: "bottom", value: "bottom" },
    { label: "border", value: "full" }
  ];
  if (border.includes(layout)) {
    return [
      styles[0],
      {
        ...styles[1],
        dropDownOptions: dropDownOptions
      }
    ];
  } else if (border1.includes(layout)) {
    return [
      styles[0],
      {
        ...styles[1],
        dropDownOptions: dropDownOptions1
      }
    ];
  } else if (border2.includes(layout)) {
    return [
      styles[0],
      {
        ...styles[1],
        dropDownOptions: dropDownOptions2
      }
    ];
  }
  return theme;
};

const generateSliderSettings = layout => {
  const sliderSettings = [
    {
      label: "Set Number of Slides to Show",
      type: "text",
      keyName: "numberOfStoriesToShow",
      placeholder: "3"
    },
    {
      label: "Navigation Arrows",
      type: "checkbox",
      keyName: "navigationArrows"
    },
    {
      label: "Choose Slide Indicator",
      type: "dropDown",
      keyName: "slideIndicator",
      dropDownOptions: [
        { label: "defaultvalue", value: "none" },
        { label: "dots", value: "dots" },
        { label: "dashes", value: "dashes" },
        { label: "none", value: "none" }
      ]
    }
  ];
  const fullScreenSliderMargin = ["ArrowFullScreenSlider"];
  const enableMargin = {
    label: "Full Width",
    type: "checkbox",
    keyName: "isFullWidth"
  };

  const sliderLayouts = ["ArrowFourStorySlider", "ArrowHalfScreenSlider"];
  if (fullScreenSliderMargin.includes(layout)) {
    return [...sliderSettings, enableMargin];
  }
  if (sliderLayouts.includes(layout)) return [...sliderSettings];
  return null;
};
const generateButtonSettings = layout => {
  const buttonSettings = {
    label: "Button Property",
    type: "dropDown",
    keyName: "footerButton"
  };

  const buttonText = {
    label: "Button Text",
    type: "text",
    keyName: "buttonText"
  };

  const dropDownOptions = [
    { label: "SubsequentLoadCount", value: "SubsequentLoadCount" },
    { label: "NavigateToPage", value: "NavigateToPage" }
  ];
  const initialLoadCount = {
    label: "Initial Stories Load Count",
    type: "text",
    keyName: "initialLoadCount"
  };
  switch (layout) {
    case "ArrowThreeColGrid":
      return [buttonText, { ...initialLoadCount, placeholder: 3 }, { ...buttonSettings, dropDownOptions }];
    case "ArrowFourColGrid":
      return [buttonText, { ...initialLoadCount, placeholder: 4 }, { ...buttonSettings, dropDownOptions }];
    case "ArrowOneColStoryList":
      return [buttonText, { ...initialLoadCount, placeholder: 6 }, { ...buttonSettings, dropDownOptions }];
    default:
      return [buttonText];
  }
};

const showHideButtonSettings = () => {
  const showButtonSettings = [
    {
      label: "Enable Button",
      type: "checkbox",
      keyName: "showButton"
    }
  ];
  return showButtonSettings;
};

const assignRowSetting = () => {
  return [
    { label: "Assign Row To", type: "text", keyName: "assignRowTo", placeholder: "Add collection slug from Bold" }
  ];
};

export const generateArrowSetting = (layout = "") => {
  let settingArray = {
    slotSettings: generateSlots(layout),
    showHideSettings: generateShowHideSettings(layout),
    styleSettings: generateStyles(layout),
    sliderSettings: generateSliderSettings(layout),
    buttonSettings: generateButtonSettings(layout),
    assignRowSetting: assignRowSetting(),
    showHideButtonSettings: showHideButtonSettings()
  };

  return settingArray;
};
